<template>
  <div
    class="form-input"
    :class="{
      'has-error': error,
      'small-input': smallInput,
    }"
  >
    <FormLabel v-if="label" class="form-input__label" :is-required="isRequired" :has-error="hasError">{{
      label
    }}</FormLabel>

    <div id="geocoder-container"></div>

    <span v-if="hint && !error" class="form-input__hint">{{ hint }}</span>
    <span v-if="error && !smallErrorMessage" class="form-input__error-msg">{{ error }}</span>
    <span
      v-if="error && smallErrorMessage"
      class="form-input__small-error-msg"
      v-tooltip="{ content: error, classes: 'error' }"
    >
      <BaseIcon name="alert-circle" class="form-input__error-icon" />
    </span>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';
import FormLabel from '@/components/form/FormLabel';
import { MapboxGeocoder } from '@mapbox/search-js-web';
import { Config } from '@/config';
import { StorageService } from '@/services/storage.service';

export default {
  name: 'FormMapSearchBox',
  components: {
    BaseIcon,
    FormLabel,
  },
  props: {
    error: {
      type: String,
      default: null,
    },
    value: {
      type: [Object, null],
      default: null,
    },
    label: String,
    isRequired: Boolean,
    hint: String,
    smallErrorMessage: Boolean,
    smallInput: Boolean,
  },
  data() {
    return {
      geocoder: null,
    };
  },
  computed: {
    Config() {
      return Config;
    },
    hasError() {
      return this.error !== '' && this.error != null;
    },
  },
  methods: {
    clear() {
      this.geocoder.search('');
    },
  },
  mounted() {
    this.geocoder = new MapboxGeocoder();
    this.geocoder.accessToken = Config.mapbox.publicKey;

    const userLocale = StorageService.getLocale();
    this.geocoder.options = {
      language: userLocale,
      country: 'CA',
    };

    this.geocoder.addEventListener('retrieve', (e) => {
      const properties = e.detail.properties;
      const context = properties.context || {};
      const coordinates = properties.coordinates;
      const fullAddress = properties.full_address;
      const city =
        context.place && context.place.name
          ? context.place.name
          : properties.feature_type === 'place'
          ? properties.name
          : null;
      const region =
        context.region && context.region.name
          ? context.region.name
          : properties.feature_type === 'region'
          ? properties.name
          : null;
      const countryName = context.country && context.country.name ? context.country.name : null;
      const postalCode = context.postcode && context.postcode.name ? context.postcode.name : null;
      this.$emit('input', { ...coordinates, fullAddress, city, region, countryName, postalCode });
    });

    document.getElementById('geocoder-container').appendChild(this.geocoder);
  },
};
</script>

<style lang="scss">
.form-input {
  padding: 24px 0;
  position: relative;
  width: 100%;

  &__label {
    bottom: 64px;
    position: absolute;
    left: 0;
  }

  &__hint {
    bottom: 4px;
    color: $color-neutral;
    font-size: 12px;
    left: 0;
    position: absolute;
  }

  &__error-msg {
    bottom: 4px;
    color: $color-error;
    font-size: 12px;
    font-style: italic;
    position: absolute;
    right: 0;
  }

  &__small-error-msg {
    bottom: 37px;
    color: $color-error;
    height: 16px;
    position: absolute;
    right: -20px;
    width: 16px;
  }

  &__error-icon {
    height: 16px;
    width: 16px;
  }

  /* MODIFIERS */
  &.small-input {
    .form-input__small-error-msg {
      left: 86px;
      right: unset;
    }
  }
}
</style>
